import { handleApi } from "common/utils/handleApi";
import { baseApiService } from "shared/api";
import { client } from "shared/api/client";

export const getCardHoldersApi = async (data) => {
  return await handleApi(() =>
    client.post(
      baseApiService.ENDPOINTS.local_admin.credit_cards.card_holders.rud,
      data
    )
  );
};

export const storeCardHolderApi = async (data) => {
  return await handleApi(() =>
    client.post(
      baseApiService.ENDPOINTS.local_admin.credit_cards.card_holders.create,
      data
    )
  );
};

export const deleteCardHolderApi = async (id) => {
  return await handleApi(() =>
    client.delete(
      baseApiService.ENDPOINTS.local_admin.credit_cards.card_holders.rud,
      {
        data: {
          card_holder_assign_id: id,
        },
      }
    )
  );
};

export const updateCardHolderApi = async (id, data) => {
  return await handleApi(() =>
    client.patch(
      baseApiService.ENDPOINTS.local_admin.credit_cards.card_holders.rud,
      {
        card_holder_assign_id: id,
        ...data,
      }
    )
  );
};
